export const PROD_URL = 'https://appointments-api-majovanilla.herokuapp.com';
export const DEV_URL = 'https://localhost:3000';
